/**
 * @file: pattern.js
 * @author: liuye11(liuye11@baidu.com)
 */

export default {
    /**
     * 手机号码，以13、14、15、18开头的11位数字
     */
    phone: /^(1[34578]\d{9})$/,
    /**
     * 包含数字、大、小写字母，长度6到32位
     */
    password: /^(?![^a-z]+$)(?![^A-Z]+$)(?![^0-9]+$)[0-9a-zA-Z]{6,32}$/,
    /**
     * 电子邮件地址正则字符串
     */
    mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    // 4位短信验证码
    smscode: /^\d{4}$/,
    // 数字，字母或汉字。用户名
    name: /^[0-9a-zA-Z\u4E00-\u9FFF]+$/
};